// extracted by mini-css-extract-plugin
export default {"form":"SignUpStepThree_form__WjxXi","title":"SignUpStepThree_title__78cLg","button":"SignUpStepThree_button__MoSpi"};